'use client';
import { BarChart, Bar, XAxis, CartesianGrid, ResponsiveContainer } from 'recharts';
import { ComparisonChartCard } from '../../Cards/ChartCards/ComparisonChartCard';
import styles from './ComparisonBarChart.module.css';

export interface ComparisonBarChartProps {
	title: string;
	mainValue?: string;
	trendValue?: string;
	trendLabel?: string;
	trendDirection?: 'up' | 'down';
	footerText?: string;
	buttonText: string;
	onButtonClick: () => void;
	data: any[];
	xAxisKey: string;
	bar1Key: string;
	bar1Label: string;
	bar2Key: string;
	bar2Label: string;
	emptyMessage?: string;
}

export const ComparisonBarChart = ({
	title,
	mainValue,
	trendValue,
	trendLabel,
	trendDirection,
	footerText,
	buttonText,
	onButtonClick,
	data,
	xAxisKey,
	bar1Key,
	bar1Label,
	bar2Key,
	bar2Label,
	emptyMessage,
}: ComparisonBarChartProps) => {
	const isEmpty = !data || data.length === 0;

	return (
		<ComparisonChartCard
			title={title}
			buttonText={buttonText}
			onButtonClick={onButtonClick}
			mainValue={mainValue}
			trendValue={trendValue}
			trendLabel={trendLabel}
			trendDirection={trendDirection}
			footerText={footerText}
			isEmpty={isEmpty}
			emptyMessage={emptyMessage}
			legend={
				<>
					<div className={styles.legendItem}>
						<div className={styles.legendDotPrimary} />
						<span className={styles.legendText}>{bar1Label}</span>
					</div>
					<div className={styles.legendItem}>
						<div className={styles.legendDotSecondary} />
						<span className={styles.legendText}>{bar2Label}</span>
					</div>
				</>
			}
		>
			<ResponsiveContainer width="100%" height="100%">
				<BarChart data={data} margin={{ top: 10, right: 10, left: 10, bottom: 0 }}>
					<CartesianGrid strokeDasharray="3 3" stroke="var(--chart-grid-line)" vertical={false} />
					<XAxis
						dataKey={xAxisKey}
						tick={{ fill: 'var(--text-secondary)', fontSize: '0.75rem' }}
						axisLine={false}
						tickLine={false}
					/>
					<Bar
						dataKey={bar1Key}
						name={bar1Label}
						fill="var(--chart-bar-primary)"
						radius={[2, 2, 0, 0]}
						maxBarSize={16}
					/>
					<Bar
						dataKey={bar2Key}
						name={bar2Label}
						fill="var(--chart-bar-secondary)"
						radius={[2, 2, 0, 0]}
						maxBarSize={16}
					/>
				</BarChart>
			</ResponsiveContainer>
		</ComparisonChartCard>
	);
};
